import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Organization } from 'src/domain/organization';
import { useOrganizationB2Cs } from 'src/view/hooks/useOrganizationB2Cs';
import { UserSelectorOption } from '../components/buttons/SelectConsumer/SelectorOption';

export const OrganizationSelector = () => {
    const { organizations } = useOrganizationB2Cs();
    const history = useHistory();
    const [currentOrgId, setCurrentOrgid] = useState('');

    useEffect(() => {
        setCurrentOrgid(history.location.pathname.split('/').pop() || '');
    }, [history.location.pathname]);
    const onSelect = (organization: Organization) => {
        setCurrentOrgid(organization.id);

        history.push(`/app/admin/organization/${organization.id}`);
    };

    return (
        <div className="flex flex-col gap-0.5 overflow-y-auto w-full">
            {organizations.map(organization => (
                <UserSelectorOption
                    key={organization.id}
                    user={organization}
                    onClick={() => onSelect(organization)}
                    isSelected={organization.id === currentOrgId}
                    variant="sidebar"
                    name={organization.organizationDisplayName}
                    entity={'ORGANISASJON'}
                    avatarUrl={organization.avatarUrl}
                />
            ))}
        </div>
    );
};
